module.exports = __webpack_public_path__ + "static/media/backspace-dark.e458fbb3.svg";